import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';

@Injectable({
  providedIn: 'root'
})
export class StatsMatrixHandlerService {

  constructor() { }

  // Event for applying matrix filters - from person search listing to person search filter
  private matrixSelectionSubject: Subject<MatrixFilter> = new Subject();

  private totalCandidatesCount: number = 0;
  private totalMedianTanureCount: number = 0;
  private malePercent: number = 0;
  private femalePercent: number = 0;
  private changedJobs: number = 0;

  get matrixSelectionEvent(): Observable<MatrixFilter> {
    return this.matrixSelectionSubject.asObservable();
  }

  emitMatrixSelectionObject(matrixEventData: MatrixFilter) {
    this.matrixSelectionSubject.next(matrixEventData);
  }

  // from person search filter to person search listing
  private filterMatrixSubject: Subject<MatrixFilter> = new Subject();

  get filterMatrixEvent(): Observable<MatrixFilter> {
    return this.filterMatrixSubject.asObservable();
  }

  emitFilterMatrixObject(matrixEventData: MatrixFilter) {
    this.filterMatrixSubject.next(matrixEventData);
  }

  /**
   * Set the static data for the person-search matrix
   * @param matrixData
   */
  setMatrixStaticData(matrixData: { totalCandidatesCount?: any, totalMedianTanureCount?: number, malePercent?: any, femalePercent?: any, changedJobs?: number }) {
    if (matrixData.totalCandidatesCount !== null && matrixData.totalCandidatesCount !== undefined) {
      this.totalCandidatesCount = matrixData.totalCandidatesCount;
    }
    if (matrixData.totalMedianTanureCount !== null && matrixData.totalMedianTanureCount !== undefined) {
      this.totalMedianTanureCount = matrixData.totalMedianTanureCount;
    }
    if (matrixData.malePercent !== null && matrixData.malePercent !== undefined) {
      this.malePercent = matrixData.malePercent;
    }
    if (matrixData.femalePercent !== null && matrixData.femalePercent !== undefined) {
      this.femalePercent = matrixData.femalePercent;
    }
    if (matrixData.changedJobs !== null && matrixData.changedJobs !== undefined) {
      this.changedJobs = matrixData.changedJobs;
    }
  }

  /**
   * Get the static data for the person-search matrix
   */
  get matrixStaticData() {
    return {
      totalCandidatesCount: this.totalCandidatesCount,
      totalMedianTanureCount: this.totalMedianTanureCount,
      malePercent: this.malePercent,
      femalePercent: this.femalePercent,
      changedJobs: this.changedJobs,
    }
  }

}
